
import React, { useEffect, useState } from 'react';

import Form, { Item as FormItem, GroupItem, ColCountByScreen } from 'devextreme-react/form';

import { FormTextbox, FormPhotoUploader, FormCheckBox } from '../..';
import { EmailRule } from 'devextreme-react/validator';
import { getSizeQualifier } from '../../../utils/media-query';
import { FormSelectBox } from '../../utils/form-selectbox/FormSelectBox';

export const UserNewForm = ({ initData, onDataChanged, permissiongroupData }) => {
  const [newUserData, setNewUserData] = useState({ ...initData });

  useEffect(() => {
    setNewUserData({ ...initData });
  }, [initData]);

  const updateField = (field) => (value) => {
    const newData = { ...newUserData, ...{ [field]: value } };

    onDataChanged(newData);
    setNewUserData(newData);
  };

  return (
    <Form
      className='plain-styled-form'
      screenByWidth={getSizeQualifier}
    >
      <GroupItem>
        <ColCountByScreen xs={1} sm={2} md={2} lg={2} />
        <FormItem>
          <FormTextbox
            label='Name'
            value={newUserData.displayName}
            isEditing={false}
            onValueChange={updateField('displayName')}
          />
        </FormItem>
        <FormItem>
          <FormTextbox
            label='E-Mail'
            value={newUserData.mail}
            isEditing={false}
            onValueChange={updateField('mail')}
          />
        </FormItem>
        <FormItem>
          <FormSelectBox
            label='Berechtigungen'
            width='100%'
            value={newUserData.permissiongroupId}
            dataSource={permissiongroupData}
            displayExpr='permissiongroupname'
            valueExpr='permissiongroupId'
            showClearButton={true}
            onValueChange={updateField('permissiongroupId')}
          />
        </FormItem>
        <FormItem>
          <FormCheckBox
            label='Externer Entra-Benutzer'
            value={newUserData.isEntraUser}
            onValueChange={updateField('isEntraUser')}
          />
        </FormItem>


      </GroupItem>


    </Form>
  );
};
